export const isRotorOrDiscCategory = (category) => {
  const normalized = String(category || "").trim().toLowerCase();
  if (!normalized) return false;
  return /brake/.test(normalized) && /(rotor|rotors|disc|discs)/.test(normalized);
};

export const normalizeCoating = (coating) => {
  return coating === "Coated" ? "Coated" : "Non-coated";
};

export const getDisplayCoating = (product) => {
  if (!isRotorOrDiscCategory(product?.category)) return "";
  return normalizeCoating(product?.coating);
};
